<template lang="pug">
  div.access.user-groups-update
    e-form-modal(
    ref="modalForm"
     @submitModalForm="sendForm()"
     @deleteItem="deleteItem()"
     :hideDeleteButton="(fields.id ? true : false)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs
      slot
          e-form(:formValidator="formValidator")
            div
                div.body
                  div.col
                    e-form-group(
                      name="name"
                      inputType="input"
                      label="Название группы"
                      :model="fields"
                      tabView="tab1"
                      :required="true"
                    )
                  div.col
                  div.col

                div.body
                  div.col
                    div.col-block.col-block--2-from-3
                      div
                        div
                          e-role-editor(
                           :model="fields"
                           name="permissions"
                           :permissionList="permissionList"
                          )

                  //div.col
                  //div.col



</template>

<script>
  import {core, access} from '../../api/api-endpoints.js'
  import adminForm from './mixins/admin-form.js'
  import ETabs from "../../components/tabs/tabs";

  export default {
    components: {ETabs},
    mixins: [adminForm],
    data () {
      return {
        tabView: 'tab1',
        fields: {
          permissions: [],
          name: ''
        },
        errors: null
      }
    },
    computed: {
      formTitle () {
        if (this.fields && this.fields.id) {
          return this.fields.name
        }
        return this.$translate('Создание группы пользователей')
      },
      permissionList () {
        try {
          return this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint()).permission_modules
        } catch (e) {
          return []
        }
      }
    },
    methods: {
      getCollectionEndpoint () {
        return core.collection('permission_modules')
      },
      getDeleteUrl (id) {
        return access.groupDelete(id)
      },
      getUpdateOrCreateUrl () {
        return access.groupUpdateOrCreate(this.$route.params.id)
      },
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return access.group(route.params.id)
      }
    },
    asyncData ({store, route, fromRoute, methods}) {
      let promises = []
      if (methods.getItemEndpoint(route, fromRoute) !== null) {
        promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))
      }

      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getCollectionEndpoint()}))

      if (promises.length === 0) {
        return Promise.resolve(1)
      }

      return Promise.all(promises)
    }
  }
</script>
